import { t } from '@lingui/core/macro';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router';

import { type OpportunityStatusOldType } from '@/api/opportunity';
import { Page, PageDateRangeFilter, PageFilterProvider } from '@/components/page';
import { exampleAIQuestions } from '@/constants/exampleAIQuestions';
import { cn } from '@/lib/utils';

import AttributionBreakdownTables from './AttributionBreakdownTables';
import AttributionKPIMetrics from './AttributionKPIMetrics';
import AttributionOverviewActions from './AttributionOverviewActions';
import AttributionTrendsChart from './AttributionTrendsChart';

const AttributionOverview = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const oppType = searchParams.get('oppType');

  useEffect(() => {
    if (oppType !== 'pipeline' && oppType !== 'closedWon') {
      setSearchParams({ oppType: 'pipeline' }, { replace: true });
    }
  }, [oppType, setSearchParams]);

  const handleOppTypeChange = (value: OpportunityStatusOldType) => {
    setSearchParams({ oppType: value });
  };

  if (oppType !== 'pipeline' && oppType != 'closedWon') {
    return null;
  }

  return (
    <Page
      title={t`Analytics`}
      pageName={t`Attribution`}
      exampleAIQuestions={exampleAIQuestions('analytics')}
    >
      <div className={cn('flex w-full flex-col gap-6')}>
        <PageFilterProvider>
          <div className="flex items-start justify-between">
            <PageDateRangeFilter />
            <AttributionOverviewActions oppType={oppType} onOppTypeChange={handleOppTypeChange} />
          </div>
          <AttributionKPIMetrics />
          <AttributionTrendsChart oppType={oppType} />
          <AttributionBreakdownTables oppType={oppType} />
        </PageFilterProvider>
      </div>
    </Page>
  );
};

export default AttributionOverview;
